._EmailIcon_6tb90_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
}